'use strict';

const clientSideValidation = require('../components/clientSideValidation');
const israeliId = require('../components/israeliId');

module.exports = {
    init: function () {
        $('body').on('change', 'select.form-control', function (e) {
            var $form = $(e.target).parents('form');
            if ($form.length) {
                clientSideValidation.functions.clearForm($form);
                clientSideValidation.functions.validateForm($form, null);
            }
        });

        // Real-time Luhn feedback when user leaves the ID field
        $('body').on('blur', '#employee-id', function () {
            israeliId.applyLuhnValidation($(this));
        });
    },
    sendContactUsRequest: function () {
        $(document).on('click', 'button.subscribe-contact-us', function (e) {
            e.preventDefault();
            var form = $(e.target).closest('form');
            var url = form.attr('action');

            var formValidate = clientSideValidation.functions.validateForm(form, null);
            // Luhn runs AFTER validateForm: validateForm strips is-invalid when HTML5 passes,
            // so Luhn must write its error state second.
            var luhnValid = israeliId.applyLuhnValidation(form.find('#employee-id'));

            if (formValidate && luhnValid) {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (response) {
                        $.spinner().stop();
                        if (response?.error) {
                            if (response.fieldErrors.length) {
                                const formHelpers = require('base/checkout/formErrors');
                                response.fieldErrors.forEach(function (error) {
                                    if (Object.keys(error).length) {
                                        formHelpers.loadFormErrors('.contact-us', error);
                                    }
                                });
                            }
                        } else {
                            $('.contact-us-landing-page.original').addClass('d-none');
                            $('.contact-us-landing-page.fake').removeClass('d-none');
                            $('html, body').animate({ scrollTop: 0 }, 'slow');
                        }
                    },
                    error: function () {
                        $('.contact-us').trigger('reset');
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    hideSpinnerOnModalClose: function () {
        $('#contactUsModal').on('hidden.bs.modal', function () {
            $.spinner().stop();
        });
    },

    showOrders: function () {
        $('#contact-topic').on('change', function () {
            var $this = $(this);
            if ($this.val() === 'cancelOrder') {
                var url = $this.attr('data-link');
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    success: function (data) {
                        var html = data && data.html ? data.html : '';
                        if (html) {
                            $('.orders-container').html('');
                            $('.orders-container').html(html);
                            $('.order-table').removeClass('d-none');
                        }
                        $.spinner().stop();
                    }
                });
            } else {
                $('.order-table').addClass('d-none');
            }
        });
    }
};
